// CategoryPage.js

import React, { useEffect } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import "./CategoryPage.css";

function normalizeString(str) {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .replace(/\s+/g, "-")
    .toLowerCase();
}

function CategoryPage({ artworks }) {
  const { category } = useParams();

  
  const [searchParams, setSearchParams] = useSearchParams();
 
  const currentPage = Number(searchParams.get("page")) || 1;

 
  const normalizedCategory = Object.keys(artworks).find(
    (cat) => normalizeString(cat) === category
  );

  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage, category]);

  
  if (!normalizedCategory) {
    return (
      <div className="error-message">
        <h1>Category Not Found</h1>
        <Link to="/obras">Go Back to Works</Link>
      </div>
    );
  }

  const categoryArtworks = artworks[normalizedCategory];

  // Paginación: calculamos cuántas páginas hay
  const itemsPerPage = window.innerWidth > 768 ? 12 : 6; 
  const totalPages = Math.ceil(categoryArtworks.length / itemsPerPage);

  // Calculamos los artworks a mostrar en la página actual
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentArtworks = categoryArtworks.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setSearchParams({ page }); 
    }
  };

  return (
    <div className="category-container">
      <h1 className="category-title">{normalizedCategory}</h1>

      <div className="artworks-grid">
        {currentArtworks.map((artwork, index) => (
          <Link
            to={`/obras/${category}/${normalizeString(artwork.title)}`}
            key={index}
            className="artwork-card"
          >
            <img src={artwork.image} alt={artwork.title} className="artwork-image" />
            <div className="artwork-title">{artwork.title}</div>
          </Link>
        ))}
      </div>

      {/* Paginación */}
      <div className="pagination">
        <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
          Anterior
        </button>
        {Array.from({ length: totalPages }, (_, i) => {
          const pageNumber = i + 1;
          return (
            <button
              key={pageNumber}
              onClick={() => goToPage(pageNumber)}
              className={currentPage === pageNumber ? "active" : ""}
            >
              {pageNumber}
            </button>
          );
        })}
        <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
          Siguiente
        </button>
      </div>
    </div>
  );
}

export default CategoryPage;